import { FaGift, FaGuitar, FaMusic } from "react-icons/fa";

export function Clases() {
  return (
    <section className="py-10 sm:py-16 bg-gray-200">
      <div className="container mx-auto px-4 md:px-10">
        {/* Título */}
        <h2 className="text-center text-4xl sm:text-6xl md:text-7xl font-bold text-blue-900/70 mb-8 md:mb-10 tracking-wider">
          CLASES
        </h2>

        {/* Banner: primera clase gratuita */}
        <div className="mb-8 md:mb-10">
          <div className="rounded-2xl shadow-xl overflow-hidden bg-gradient-to-r from-clases-primary via-[#214C7A] to-[#0B3A6E]">
            <div className="max-w-5xl mx-auto px-5 sm:px-8 py-5 sm:py-6 flex flex-col sm:flex-row sm:items-center sm:justify-between gap-4">
              <div className="flex items-start gap-4">
                <div className="bg-orange-500/95 text-white rounded-xl w-11 h-11 flex items-center justify-center shadow-lg flex-shrink-0">
                  <FaGift className="text-2xl" />
                </div>
                <div>
                  <p className="text-white font-extrabold tracking-wide text-xl sm:text-2xl">
                    Primera clase gratuita
                  </p>
                  <p className="text-white/90 text-sm sm:text-base">
                    Prueba sin compromiso y definimos tu plan de aprendizaje.
                  </p>
                </div>
              </div>

              <div className="flex flex-col sm:flex-row gap-3">
                <a
                  href="#contacto"
                  className="inline-flex items-center justify-center rounded-full bg-white text-clases-primary px-6 py-2.5 font-semibold shadow-md hover:opacity-90 transition"
                >
                  Reservar clase
                </a>
                <a
                  target="_blank"
                  rel="noopener noreferrer"
                  href="https://wa.me/34616077104"
                  className="inline-flex items-center justify-center rounded-full border border-white/70 text-white px-6 py-2.5 font-semibold hover:bg-white hover:text-clases-primary transition"
                  aria-label="Reservar por WhatsApp"
                >
                  WhatsApp
                </a>
              </div>
            </div>
          </div>
        </div>

        {/* Sobre Ricardo */}
        <div className="pb-8 flex flex-col md:flex-row items-stretch md:items-center gap-6 md:gap-8">
          {/* Vídeo */}
          <div className="w-full md:w-2/5">
            <video
              className="w-full rounded-lg shadow-2xl object-cover"
              autoPlay
              muted
              loop
            >
              <source src="/GuitarVideo3.mp4" type="video/mp4" />
              Tu navegador no soporta el elemento de video.
            </video>
          </div>

          {/* Card Sobre Ricardo */}
          <div className="w-full md:w-3/5 bg-white rounded-xl shadow-lg px-6 py-5 flex flex-col justify-center">
            <p className="text-lg leading-relaxed text-gray-700 text-justify">
              Las clases de Ricardo Fernández, músico profesional, ex profesor
              de Union Musical Grupo Adagio S.A, y titulado superior en sonido
              para audiovisuales en el CIFP Jose Luis Garci están diseñadas para
              proporcionar al alumno los recursos necesarios que necesite en
              función de las expectativas del mismo en su carrera como músico.
            </p>
            <div className="my-4 border-t border-gray-300" />
            <p className="text-lg leading-relaxed text-gray-700 text-justify">
              La piedra angular de las clases siempre será la creatividad ligada
              a la sensibilidad musical. La adaptación a las características
              cognitivas y físicas del alumno, son la clave para poder comprobar
              resultados muy pronto.
            </p>
          </div>
        </div>

        {/* Contenido de clases + cards */}
        <div className="pt-8 md:pt-12 flex flex-col md:flex-row gap-6 md:gap-10 items-start">
          {/* Imagen */}
          <div className="w-full md:w-[40%] lg:w-[38%]">
            <img
              src="/ricardo-guitarra-artguru.jpeg"
              alt="Clases de guitarra"
              className="w-full h-auto rounded-lg shadow-2xl object-cover"
            />
          </div>

          {/* Cards apiladas */}
          <div className="w-full md:w-[60%] lg:w-[62%] space-y-6 md:space-y-8">
            {/* Card Contenido clases estándar */}
            <div className="bg-white rounded-xl shadow-lg p-6 sm:p-8">
              <h4 className="text-xl sm:text-3xl font-bold text-blue-900 mb-3 sm:mb-6">
                Contenido clases estándar
              </h4>
              <p className="text-lg leading-relaxed text-gray-700 mb-4">
                Las enseñanzas permiten desarrollar al alumno todas sus
                aptitudes musicales, en función de su perfil como músico,
                acercándonos a los estilos más destacados desde la antigüedad
                hasta el modernismo musical o la música contemporánea.
              </p>
              <div className="my-4 border-t border-gray-300" />
              <p className="text-lg leading-relaxed text-gray-700">
                Para la elaboración de la programación docente, se tiene en
                cuenta el perfil musical del alumno.
              </p>
            </div>

            {/* Card Desarrollo */}
            <div className="bg-white rounded-xl shadow-lg p-6 sm:p-8">
              <h4 className="text-xl sm:text-3xl font-bold text-blue-900 mb-3 sm:mb-6">
                Desarrollo
              </h4>
              <p className="text-lg leading-relaxed text-gray-700 mb-4">
                Las clases no acaban en el aula, tienes acceso a preguntar lo
                que quieras durante cualquier día hábil de la semana. El
                compromiso con el desarrollo del alumno se traduce en una amplia
                disponibilidad para resolver dudas. Si lo deseas tus familiares
                y amigos pueden seguir las clases y tu evolución en directo.
              </p>
              <div className="mt-4 p-4 bg-gradient-to-b from-clases-secondary to-clases-primary rounded-lg shadow-lg">
                <p className="text-white text-base font-bold text-center italic">
                  "Tú nos marcas la dirección, nosotros te ayudamos a alcanzar
                  la meta."
                </p>
              </div>
            </div>

            {/* Card Promociones */}
            <div className="bg-white rounded-xl shadow-lg p-6 sm:p-8">
              <h4 className="text-xl sm:text-3xl font-bold text-blue-900 mb-3 sm:mb-6">
                Promociones
              </h4>
              <p className="text-lg leading-relaxed text-gray-700 mb-6">
                Durante el curso el alumno podrá optar a promociones y contenido
                exclusivo, en función de su perfil como guitarrista.
              </p>
              <div className="my-4 border-t border-gray-300" />
              <ul className="space-y-4">
                <li className="flex items-start gap-3">
                  <FaGuitar className="text-orange-600 text-2xl flex-shrink-0 mt-1" />
                  <span className="text-lg italic leading-relaxed text-gray-700">
                    Contenido exclusivo personalizado
                  </span>
                </li>
                <li className="flex items-start gap-3">
                  <FaMusic className="text-orange-600 text-2xl flex-shrink-0 mt-1" />
                  <span className="text-lg italic leading-relaxed text-gray-700">
                    Descuentos en material didáctico
                  </span>
                </li>
                <li className="flex items-start gap-3">
                  <FaGift className="text-orange-600 text-2xl flex-shrink-0 mt-1" />
                  <span className="text-lg italic leading-relaxed text-gray-700">
                    Acceso a masterclasses especiales
                  </span>
                </li>
              </ul>
              <div className="mt-4 p-4 bg-gradient-to-b from-clases-secondary to-clases-primary rounded-lg shadow-lg">
                <p className="text-white text-base font-bold text-center italic">
                  ¡Aprovecha la clase de prueba de forma totalmente gratuita!
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
